import { CountryApi } from '@myre/app-entity-generated/sdk/angular/CountryApi';
import { type Country } from '@myre/app-entity-generated/types/Country';

import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountryService {
  private readonly _countryApi = inject(CountryApi);

  public getCountries(): Observable<readonly Country[]> {
    return this._countryApi.getCountries();
  }
}
